var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uyh-learn-how"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('learn_how_message'))}}),_c('router-link',{attrs:{"to":"get-started"}},[_vm._v(_vm._s(_vm.$t('get_started')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }